var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"page-title-box"},[_c('h4',{staticClass:"font-size-18"},[_vm._v("Dashboard")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }